import { Box, FormControl, FormGroup, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { useMemo } from "react";
import { schedulingStrategies } from "../../../../types/actionModule/actionModuleTypes";
import { ActionModuleSchedulingStrategyState } from "../../../../types/actionModule/editor/actionModuleEditorTypes";
import { SchedulingStrategyType } from "../../../../types/actionModule/schedulingStrategy/schedulingStrategyType";
import { useTranslation } from "react-i18next";

interface Props {
    value: ActionModuleSchedulingStrategyState;
    onChange: (value: ActionModuleSchedulingStrategyState) => void;
}

export default function SchedulingStrategyEditor(props: Props) {
    const { t } = useTranslation();
    const schedulingStrategy = useMemo(() =>
        schedulingStrategies.find((i) => i.type === props.value.selectedSchedulingStrategyType),
        [props.value.selectedSchedulingStrategyType],
    );

    const onChangeSchedulingStrategyType = (newType: SchedulingStrategyType) => {
        const schedulingStrategy = schedulingStrategies.find(
            (i) => i.type === newType,
        );

        props.onChange({
            selectedSchedulingStrategyType: newType,
            schedulingStrategy: {
                ...schedulingStrategy?.defaultValue ?? {},
                type: newType
            }
        });
    };

    return <Box sx={{ p: 2 }}>
        <Typography variant="subtitle2">{t("actionModuleEditor.tabSchedulingStrategy.common")}</Typography>
        <FormGroup sx={{ gap: 2, pb: 2, pt: 1 }}>
            <FormControl sx={{ minWidth: 250, flex: 1 }}>
                <InputLabel>{t("actionModuleEditor.tabSchedulingStrategy.schedulingStrategyType")}</InputLabel>
                <Select
                    value={props.value.selectedSchedulingStrategyType}
                    size="small"
                    fullWidth
                    label={t("actionModuleEditor.tabSchedulingStrategy.schedulingStrategyType")}
                    onChange={
                        (v) => onChangeSchedulingStrategyType(v.target.value as SchedulingStrategyType)
                    }>
                    {
                        schedulingStrategies.map((s) =>
                            <MenuItem value={s.type}>{t(s.name)}</MenuItem>
                        )
                    }
                </Select>
            </FormControl>
        </FormGroup>
        {
            schedulingStrategy && <>
                {
                    schedulingStrategy.editor({
                        value: props.value.schedulingStrategy,
                        onChanged: (v) => props.onChange({
                            ...props.value,
                            schedulingStrategy: v,
                        })
                    })
                }
            </>
        }
    </Box>
}
